const ready = (state = false, action) => {
  switch (action.type) {
    case '@@_AFTER_RENDER':
      return true
    default:
      return state
  }
}

export default ready
